import { useCallback } from 'react';
import ga from '../ga';
import { EventDefined } from './event';

export const useGA4 = () => {
    const event = useCallback(
        <
            EventName extends keyof EventDefined,
            Params extends EventDefined[EventName]
        >(
            eventName: EventName,
            params: Params
        ) => {
            if (typeof window !== 'object') return;
            console.log(eventName, params);
            ga.eventGA4(eventName, params);
        }, []
    );
    return { event };
};